// Fonction modifiée pour créer un en-tête de mois
export function createMonthHeader(month, year) {
  const dateObj = new Date(year, month, 1);
  const monthName = dateObj.toLocaleString('fr-FR', { month: 'long' });

  const header = document.createElement('div');
  header.className = 'month-header';

  const h3 = document.createElement('h3');
  h3.textContent = monthName;

  header.appendChild(h3);
  return header;
}